import { DynamicEntityDto, DynamicFormDto } from './../../../service/dto';
import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicPropertyDto, DynamicTypeEnum, DynamicValueDataTypeEnum } from '../../../service/dto';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { HttpDynamicService } from '../../../service/http-dynamic.service';
import { filter, map, Observable } from 'rxjs';

@Component({
	selector: 'app-dynamic-entity-modal',
	standalone: false,
	templateUrl: './dynamic-entity-modal.component.html',
	styleUrl: './dynamic-entity-modal.component.scss'
})
export class DynamicEntityModalComponent {
	form!: FormGroup;
	optionForms!: FormArray;

	dynamicTypes: DynamicTypeEnum[] = ['Dynamic', 'Field'];
	dataTypesDynamic: DynamicValueDataTypeEnum[] = ['Text', 'TextArea', 'Boolean', 'DropDownSingle', 'Number', 'PastDate', 'FutureDate', 'Time', 'PastDateTime', 'FutureDateTime', 'File', 'Password', 'Email', 'Msisdn','Hierarchy'];
	dataTypesField: DynamicValueDataTypeEnum[] = ['Text', 'TextArea', 'Boolean', 'DropDownSingle', 'Number', 'PastDate', 'FutureDate', 'Time', 'PastDateTime', 'FutureDateTime', 'File', 'Password', 'Email', 'Msisdn', 'SetOfRecords', 'SelectFromRecords','Hierarchy'];
	dataTypes: DynamicValueDataTypeEnum[] = [];
	allDynamicEntities: DynamicEntityDto[] = [];


	@Input()
	input!: DynamicPropertyDto;

	@Input()
	dynamicEntity!: DynamicEntityDto;
	constructor(private fb: FormBuilder, private modalRef: NzModalRef, private service: HttpDynamicService) { }

	ngOnInit(): void {

		let sectionId = this.dynamicEntity!.template.sections.filter(item => item.id === this.input.sectionId).length > 0 ? this.input.sectionId : undefined;
		this.dataTypes = (this.input.type == 'Field' && this.dynamicEntity.subEntityTypes.length > 0) ? this.dataTypesField : this.dataTypesDynamic;
		this.service.getAll().subscribe(result => {
			this.allDynamicEntities = result.filter((item: DynamicEntityDto) => this.dynamicEntity.subEntityTypes.indexOf(item.entityType) != -1);
		});

		this.form = this.fb.group({
			property: [this.input.property, [Validators.required, Validators.minLength(1), Validators.maxLength(100), Validators.pattern('^[a-zA-Z_][a-zA-Z0-9_]*$')]],
			name: [this.input.name ?? '', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]],
			description: [this.input.description ?? '', [Validators.required, Validators.minLength(1), Validators.maxLength(255)]],
			bulkImportColumnName: [this.input.bulkImportColumnName ?? ''],
			dataType: [this.input.dataType ?? 'Text', [Validators.required]],
			icon: [this.input.icon],
			required: [this.input.required ?? true, [Validators.required]],
			errorMessageRequired: [this.input.errorMessageRequired ?? '', [Validators.maxLength(255)]],
			isUnique: [this.input.isUnique ?? false, [Validators.required]],
			errorMessageUnique: [this.input.errorMessageUnique ?? '', [Validators.maxLength(255)]],
			regex: [this.input.regex ?? ''],
			errorMessageRegex: [this.input.errorMessageRegex ?? ''],
			minValue: [this.input.minValue ?? '', [Validators.pattern('^[0-9]+$')]],
			errorMessageMinValue: [this.input.errorMessageMinValue ?? ''],
			maxValue: [this.input.maxValue ?? '', [Validators.pattern('^[0-9]+$')]],
			errorMessageMaxValue: [this.input.errorMessageMaxValue ?? ''],
			sectionId: [sectionId ?? '', [Validators.required]],
			orderIndex: [this.input.orderIndex ?? '', [Validators.required]],
			activeOnCreate: [this.input.activeOnCreate ?? true, [Validators.required]],
			activeOnUpdate: [this.input.activeOnUpdate ?? true, [Validators.required]],
			searchable: [this.input.searchable ?? false, [Validators.required]],
			dependencyValue: [this.input.dependencyValue ?? '', [Validators.required]],
			dependencyId: [this.input.dependencyId]
		});
		this.optionForms = this.fb.array(this.input.options.map(item => this.fb.group({
			value: [item.value, [Validators.required]],
			label: [item.label, [Validators.required]]
		})));

		this.initOptions(this.input.dataType);
		this.initDependencyValue(this.input.dependencyId);
		this.form.get('dataType')!.valueChanges.subscribe(value => this.initOptions(value));
		this.form.get('dependencyId')!.valueChanges.subscribe(value => this.initDependencyValue(value));
	}
	private initDependencyValue(dependencyId: number | undefined) {
		if (dependencyId) {
			if (!this.form.contains('dependencyValue')) {
				this.form.addControl('dependencyValue', [this.input.dependencyValue, [Validators.required]]);
			}
		} else {
			if (this.form.contains('dependencyValue')) {
				this.form.removeControl('dependencyValue');
			}
		}
	}
	private initOptions(dataType: DynamicValueDataTypeEnum) {
		if (dataType === 'DropDownSingle') {
			if (!this.form.contains('options')) {
				this.form.addControl('options', this.optionForms);
			}
			if (this.form.contains('subDynamic')) {
				this.form.removeControl('subDynamic');
			}
		} else if (dataType == 'SetOfRecords' || dataType == 'SelectFromRecords') {
			if (this.form.contains('options')) {
				this.form.removeControl('options');
			}
			if (!this.form.contains('subDynamic')) {
				this.form.addControl('subDynamic', this.fb.control(this.input.subDynamic, [Validators.required]));
			}
		} else {
			if (this.form.contains('options')) {
				this.form.removeControl('options');
			}
			if (this.form.contains('subDynamic')) {
				this.form.removeControl('subDynamic');
			}
		}
	}

	addOption(): void {
		const option = this.fb.group({
			value: ['', Validators.required],
			label: ['', Validators.required]
		});
		this.optionForms.push(option);
	}

	removeOption(index: number): void {
		this.optionForms.removeAt(index);
	}

	onSubmit(): void {
		if (this.form.valid) {
			console.log('Form Value:', this.form.value);
		} else {
			this.form.markAllAsTouched();
		}
	}
	get hasDependency(): boolean {
		return this.form && this.form.get('dependencyId')!.value != undefined;
	}
	get dataType(): DynamicValueDataTypeEnum {
		return this.form && this.form.get('dataType')!.value;
	}
	get icon(): string{
		return this.form.get('icon')!.value;
	}

	doCancel() {
		this.modalRef.close({ action: 'cancel' });
	}
	doTouchAllFields(group: FormGroup | FormArray = this.form) {
		Object.values(group.controls).forEach(control => {
			if (control instanceof FormControl) {
				control.markAsDirty({ onlySelf: true });
				control.updateValueAndValidity({ onlySelf: true });
			} else if (control instanceof FormGroup || control instanceof FormArray) {
				this.doTouchAllFields(control);
			}
		});
	}
	doDelete() {
		console.log('Closing modal');
		this.modalRef.close({ action: 'delete', value: this.input });
	}
	doSave() {
		let order = 0;


		const out: DynamicPropertyDto = {
			id: this.input.id,
			createdAt: this.input.createdAt,
			property: this.form.get('property')!.value,
			name: this.form.get('name')!.value,
			bulkImportColumnName: this.form.get('bulkImportColumnName')!.value,
			description: this.form.get('description')!.value,
			type: this.input.type,
			dependencyId: this.form.get('dependencyId')!.value,
			sectionId: this.form.get('sectionId')!.value,
			orderIndex: this.form.get('orderIndex')!.value,
			icon: this.form.get('icon')!.value,
			activeOnCreate: this.form.get('activeOnCreate')!.value,
			activeOnUpdate: this.form.get('activeOnUpdate')!.value,
			searchable: this.form.get('searchable')!.value,
			dataType: this.form.get('dataType')!.value,
			isUnique: this.form.get('isUnique')!.value,
			minValue: this.form.get('minValue')!.value,
			maxValue: this.form.get('maxValue')!.value,
			required: this.form.get('required')!.value,
			regex: this.form.get('regex')!.value,
			dependencyValue: this.form.get('dependencyValue')?.value,
			errorMessageUnique: this.form.get('errorMessageUnique')!.value,
			errorMessageRequired: this.form.get('errorMessageRequired')!.value,
			errorMessageRegex: this.form.get('errorMessageRegex')!.value,
			errorMessageMinValue: this.form.get('errorMessageMinValue')!.value,
			errorMessageMaxValue: this.form.get('errorMessageMaxValue')!.value,
			fieldDisabled: false,
			options: this.optionForms.controls.map(item => {
				return {
					hashCode: 0,
					label: item.get('label')!.value,
					value: item.get('value')!.value,
					orderIndex: order++
				}
			}),
			subDynamic: this.form.get('subDynamic')?.value,
			hashCode: 0
		}


		this.modalRef.close({
			action: 'submit',
			value: out
		});
	}

	getInvalidControlsList(
		group: FormGroup | FormArray = this.form,
		path: string = ''
	): { field: string; errors: string }[] {
		let invalid: { field: string; errors: string }[] = [];

		Object.keys(group.controls).forEach(key => {
			const controlPath = path ? `${path}.${key}` : key;
			const control = group.get(key)!;

			if (control instanceof FormControl) {
				if (control.invalid) {
					const errorKeys = Object.keys(control.errors || {}).join(', ');
					invalid.push({ field: controlPath, errors: errorKeys });
				}
			} else if (control instanceof FormGroup || control instanceof FormArray) {
				invalid = invalid.concat(this.getInvalidControlsList(control, controlPath));
			}
		});

		return invalid;
	}
	compareSelectValues = (o1: any, o2: any): boolean => o1 && o2 ? o1.id === o2.id : o1 === o2;
}
